import Axios from '../context/axios/AxiosControl'

export const getLogs = (page = null, limit = null, search = '') => async (dispatch) => {
    dispatch({
        type: 'LOG_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/log/getall/', { page, limit, search }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if(status===200){
            dispatch({
                type: 'LOG_GET_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({ type: 'LOG_ERROR' })
    }
}